const EventBusType = {
  SESSION_EXPIRED: 'SESSION_EXPIRED' as 'SESSION_EXPIRED',
};

type EventBusType = typeof EventBusType[keyof typeof EventBusType];

export { EventBusType };